import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useStorefrontRefresh } from '../../hooks/useStorefrontRefresh';
import { useAuthStore } from '../../store/authStore';
import { startAccountSync } from '../../store/accountSync';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import { StorefrontContentProvider } from '../../hooks/useStorefrontContent';

export default function StorefrontLayout() {
  useStorefrontRefresh();
  const fetchMe = useAuthStore((state) => state.fetchMe);
  useEffect(() => startAccountSync(), []);
  useEffect(() => {
    void fetchMe();
  }, [fetchMe]);
  return (
    <StorefrontContentProvider>
      <div className="app">
        <Header />
        <main className="app__main">
          <Outlet />
        </main>
        <Footer />
      </div>
    </StorefrontContentProvider>
  );
}
